import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';

const tabSlideSound = createInterfaceSound('/sound/slide.wav');

const playTabSlideSound = () => {
    tabSlideSound.currentTime = 0;
    playInterfaceSound(tabSlideSound).catch(() => undefined);
};

const isDisabledTab = (tab: Element) => (
    tab.classList.contains('v-tab--disabled') ||
    tab.getAttribute('disabled') !== null ||
    tab.getAttribute('aria-disabled') === 'true'
);

const isActiveTab = (tab: Element) => (
    tab.classList.contains('v-tab--active') ||
    tab.getAttribute('aria-selected') === 'true'
);

const onTabInteraction = (target: EventTarget | null) => {
    if (!(target instanceof Element)) {
        return;
    }

    const tabElement = target.closest('.v-tab');
    if (!tabElement || isDisabledTab(tabElement) || isActiveTab(tabElement)) {
        return;
    }

    playTabSlideSound();
};

document.addEventListener('click', event => {
    onTabInteraction(event.target);
}, true);

document.addEventListener('keydown', event => {
    if (event.key !== ' ' && event.key !== 'Enter') {
        return;
    }

    onTabInteraction(event.target);
}, true);
